
<!--
  @component
  
  Splits text into multiple paragraphs by double newline characters.
-->
<script lang="ts">
  export let text: string;

  $: content = text.split(/\r?\n\s*\r?\n/);
</script>

{#each content as paragraph}
  <p>{paragraph}</p>
{/each}

<style>
  p { white-space: pre-line; }
</style>